
import { Autocomplete, TextField,CircularProgress ,Box} from "@mui/material";

const AssetFilter = ({ pltConstants,error,isRequired, dropDownLoader, reportData, onFieldChange,onFocusChange }) => {
    const onClickMultiFilter = (data, type) => {if (type === "all") { onFieldChange("asset_type_id", data); } else { onFieldChange("asset_type_id", []); } };
    return (
        <>
            <p className='lessor-select'><span onClick={() => onClickMultiFilter(pltConstants?.asset, "all")}>Select All Asset</span>{reportData?.asset_type_id?.length ? <span style={{ marginLeft: '8px' }} onClick={() => onClickMultiFilter(pltConstants?.asset, "remove")} >Remove All Asset</span> : null}</p>
            <Autocomplete
                disablePortal
                options={pltConstants?.asset || []}
                multiple
                noOptionsText={dropDownLoader?.asset ? "Loading..." : "No options"}
                value={reportData?.asset_type_id || []}
                getOptionLabel={(option) => option.name || ""}
                onChange={(e, value) => onFieldChange("asset_type_id", value)}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onFocus={() =>isRequired && onFocusChange("asset_type_id")}
                renderOption={(props, option) => ( <Box component="li" {...props} key={option.slug}> {option.name} </Box> )}
                renderInput={(params) => (
                    <TextField
                    {...params}
                    onFocus={()=> isRequired && onFocusChange("asset_type_id")}
                    label={isRequired ? "Asset *" :"Asset"}
                    margin="normal"
                    size="small"
                    placeholder="Select Asset(s)"
                    error={isRequired && Boolean(error?.asset_type_id)}
                    helperText={isRequired ? error?.asset_type_id : ""}
                    slotProps={{
                      input: {
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {dropDownLoader?.asset && (
                              <CircularProgress color="inherit" size={18} />
                            )}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      },
                      inputLabel: { shrink: true },
                    }}
                  />
                )}
            />
        </>
    )
}

export default AssetFilter
